export const INCOME = "#2E7D5C";
export const EXPENSE = "#C75D42";
export const PRIMARY = "#4A5D4E";
export const CHART_COLORS = ["#4A5D4E", "#C75D42", "#8A9A5B", "#D9A566", "#5B7B7A", "#A65E4E", "#7D6B57", "#9CAF88"];

const eur = new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" });

export function fmtEUR(v) {
  return eur.format(Number(v || 0));
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("pt-PT", { day: "2-digit", month: "short", year: "numeric" });
}

export function monthLabel(key) {
  const [y, m] = key.split("-");
  const meses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
  return `${meses[parseInt(m, 10) - 1]}/${y.slice(2)}`;
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
